import * as React from 'react';
import styled from 'styled-components';

interface MessageBubbleProps {
  type: 'sent' | 'received';
  children: React.ReactNode;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({
  type,
  children,
}) => {
  return <MessageBubbleStyled type={type}>{children}</MessageBubbleStyled>;
};

const MessageBubbleStyled = styled.div<{ type: 'sent' | 'received' }>`
  border-radius: 8px;
  background-color: ${(props) =>
    props.type === 'sent'
      ? props.theme.atlas.semantic.color.surface.variant
      : props.theme.atlas.semantic.color.surface.variant};
  padding: 12px 16px;
  max-width: 217px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: 400;
  font-size: 12px;
  width: max-content;
  align-self: ${(props) => (props.type === 'sent' ? 'flex-end' : 'flex-start')};
`;
